import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./slices/cartSlice";
import authReducer from "./slices/authSlice";
import wishlistReducer from "./slices/wishlistSlice";
import orderReducer from "./slices/orderSlice";
import loginReducer from "./slices/loginSlice";
import userReducer from "@/modules/user/userSlice";
import cmsReducer from "@/modules/cms/cmsSlice";
import categoryReducer from "@/modules/category/category.slice";
import discountReducer from "@/modules/discount/discount.slice";
import blogReducer from "@/modules/blog/blog.slice";
import customerReducer from "@/modules/customer/customerSlice";
import productReducer from "@/modules/product/productSlice";
import paymentMethodReducer from "@/modules/payment-method/paymentMethod.slice";
import drawerReducer from "./slices/drawerSlice";
import paginationReducer from "./slices/paginationSlice";
import shopReducer from "@/modules/shop/shop.slice";
import bookingReducer from "@/modules/booking/booking.slice";
import seotagReducer from "@/modules/seotag/seotagSlice";
import settingReducer from "@/modules/setting/setting.slice";
import homeReducer from "@/modules/home/home.slice";
import dashboardReducer from "@/modules/dashboard/dashboardSlice";
import inquiryReducer from "@/modules/inquiry/inquirySlice";
import priceRangeReducer from "@/modules/price-range/priceRange.slice";
import testimonialReducer from "@/modules/testimonial/testimonial.slice";
import locationReducer from "./slices/locationSlice";

export const store = configureStore({
  reducer: {
    location: locationReducer,
    cart: cartReducer,
    auth: authReducer,
    wishlist: wishlistReducer,
    orders: orderReducer,
    login: loginReducer,
    user: userReducer,
    cms: cmsReducer,
    category: categoryReducer,
    discount: discountReducer,
    blog: blogReducer,
    customer: customerReducer,
    product: productReducer,
    paymentMethod: paymentMethodReducer,
    drawer: drawerReducer,
    pagination: paginationReducer,
    shop: shopReducer,
    booking: bookingReducer,
    seotag: seotagReducer,
    setting: settingReducer,
    home: homeReducer,
    dashboard: dashboardReducer,
    inquiry: inquiryReducer,
    priceRange: priceRangeReducer,
    testimonial: testimonialReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
